import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "sidebarContent", "overviewModal", "overviewToggle", "overviewClose"]

  connect() {
    this.initializeMobileSidebar()

    // Add event listeners
    document.addEventListener('keydown', this.closeOnEscape.bind(this))
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  // Initialize mobile sidebar state
  initializeMobileSidebar() {
    if (window.innerWidth < 768) {
      this.sidebarContentTargets.forEach(content => {
        content.classList.add('hidden')
      })
    }
  }

  // Toggle sidebar on mobile
  toggleSidebar(event) {
    this.sidebarContentTargets.forEach(content => {
      content.classList.toggle('hidden')
      content.classList.toggle('md:block')
    })

    // Toggle icon
    const svg = event.currentTarget.querySelector('svg')
    if (svg.innerHTML.includes('M19 9l-7 7-7-7')) {
      svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />'
    } else {
      svg.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />'
    }
  }

  // Open overview modal
  openOverviewModal(event) {
    if (this.hasOverviewModalTarget) {
      this.overviewModalTarget.classList.remove('hidden')
      // Prevent body scroll
      document.body.style.overflow = 'hidden'
    }
  }

  // Close overview modal
  closeOverviewModal(event) {
    if (this.hasOverviewModalTarget) {
      this.overviewModalTarget.classList.add('hidden')
      // Restore body scroll
      document.body.style.overflow = ''
    }
  }

  // Close modal on backdrop click
  closeOnBackdrop(event) {
    if (event.target === this.overviewModalTarget) {
      this.closeOverviewModal()
    }
  }

  // Close modal on escape key
  closeOnEscape(event) {
    if (event.key === 'Escape' && this.hasOverviewModalTarget && !this.overviewModalTarget.classList.contains('hidden')) {
      this.closeOverviewModal()
    }
  }

  // Handle window resize
  handleResize() {
    this.initializeMobileSidebar()
  }

  disconnect() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.closeOnEscape.bind(this))
    window.removeEventListener('resize', this.handleResize.bind(this))
  }
}